<template>
  <q-list
    class="c-list"
    :bordered="bordered"
    :dense="dense"
    :separator="separator"
    :padding="padding"
    :dark="dark"
    :class="$attrs.class"
  >
    <slot name="header" />

    <c-list-skeleton
      v-if="loading"
      :count="skeletonCount"
      :show-avatar="skeletonAvatar"
      :show-badge="skeletonBadge"
      :show-action="skeletonAction"
      :columns="skeletonColumns"
    />

    <slot v-if="!loading" />
  </q-list>
</template>

<script setup lang="ts">
import CListSkeleton from "./CListSkeleton.vue";

withDefaults(
  defineProps<{
    bordered?: boolean;
    dense?: boolean;
    separator?: boolean;
    padding?: boolean;
    dark?: boolean;
    loading?: boolean;
    skeletonCount?: number;
    skeletonAvatar?: boolean;
    skeletonBadge?: boolean;
    skeletonAction?: boolean;
    skeletonColumns?: number;
  }>(),
  {
    bordered: true,
    dense: false,
    separator: false,
    padding: false,
    dark: false,
    loading: false,
    skeletonCount: 5,
    skeletonAvatar: true,
    skeletonBadge: true,
    skeletonAction: false,
    skeletonColumns: 1,
  },
);
</script>

<style lang="scss" scoped>
.q-list {
  &.c-list {
    @apply tw-overflow-hidden tw-rounded-2xl tw-p-0;
  }

  &--bordered {
    @apply tw-border tw-border-gray-100;
  }
}
</style>
